import { defineMessages } from 'react-intl';

export default defineMessages({
  truemedButtonId: {
    id: 'TruemedButton.truemedButtonId',
    description: 'ID for Truemed button',
    defaultMessage: 'truemed-button',
  },
  truemedAltText: {
    id: 'TruemedButton.truemedAltText',
    description: 'Alt text for Truemed button',
    defaultMessage: 'Truemed logo',
  }
});